import { deserializeEntry, serializeEntry } from './company-key-serializer';
export class HttpCompanyKeyRepository {
    constructor(http, localStorage, uiFrameAdapter, logger) {
        this.http = http;
        this.localStorage = localStorage;
        this.uiFrameAdapter = uiFrameAdapter;
        this.logger = logger;
    }
    async isKeyCreationEnabled() {
        var _a, _b, _c;
        const override = (_c = (_b = (_a = this.uiFrameAdapter.options) === null || _a === void 0 ? void 0 : _a.__zeroTrustLib) === null || _b === void 0 ? void 0 : _b.featureFlagOverrides) === null || _c === void 0 ? void 0 : _c.delayedZT;
        if (override !== undefined) {
            return override;
        }
        const result = await this.http.get('feature-flags');
        return Boolean(result.delayedZT);
    }
    async getCompanyPrivateKey() {
        try {
            this.logger.logInformation('HTTP Company Key Repository: Getting company key pairs...');
            const result = await this.http.get('company-private-key');
            // save in case of a future api call error
            try {
                this.localStorage.set(this.getLocalStorageKey(), result);
            }
            catch (ex) {
                this.logger.logWarning(`HTTP Company Key Repository: ${ex}`);
            }
            this.logger.logInformation('HTTP Company Key Repository: Key pairs successfully loaded.');
            return result ? deserializeEntry(result) : null;
        }
        catch (ex) {
            this.logger.logWarning(`HTTP Company Key Repository: ${ex}`);
            // return last known result
            try {
                const lastResult = this.localStorage.get(this.getLocalStorageKey());
                if (lastResult !== null) {
                    this.logger.logInformation('HTTP Company Key Repository: Returning last known result.');
                    return lastResult ? deserializeEntry(lastResult) : null;
                }
            }
            catch (ex) {
                this.logger.logWarning(`HTTP Company Key Repository: ${ex}`);
            }
            throw ex;
        }
    }
    async addCompanyPrivateKey(data) {
        const request = serializeEntry(data);
        return this.http.post('company-private-key', request);
    }
    getLocalStorageKey() {
        return `ZeroTrust_CompanyKey_${this.uiFrameAdapter.companyId}`;
    }
}
